module.exports = __webpack_public_path__ + "static/media/landing-empty-logo.8539c322.png";